import { getAccessToken } from '../utils/session';
import {
  BASE_URL,
  ASSIGN_ENTITY_TO_USER_API,
  GET_ASSIGNED_USER_LIST_API,
  DOWNLOAD_USER_ENTITY_EXCEL_API,
  DELETE_ASSIGNED_ENTITY_API,
  DELETE_ASSIGNED_USER_ENTITY_API
} from '../endpoints/apiEndpoints';

export const assignUserToEntity = async (payload) => {
  try {
    const token = getAccessToken();
    const apiUrl = `${BASE_URL}/${ASSIGN_ENTITY_TO_USER_API}`;
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify({ entityTanMasterDTOs: payload }),
    };
    const response = await fetch(apiUrl, requestOptions);
    if (!response.ok) {
      let errorMessage;
      try {
        const errorData = await response.json();
        errorMessage =
          errorData.error || `Request failed with status: ${response.status}`;
      } catch {
        errorMessage = `Request failed with status: ${response.status}`;
      }
      throw new Error(errorMessage);
    }
    const data = await response.json();
    return {
      success: true,
      data,
    };
  } catch (error) {
    console.error('Failed to Assign Entity to User:');
    return {
      success: false,
      error: error.message || 'Failed to Assign Entity to User',
    };
  }
};

export const getAssignedUserEntityList = async (payload) => {
  try {
    const token = getAccessToken();
    const apiUrl = `${BASE_URL}/${GET_ASSIGNED_USER_LIST_API}`;
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(payload),
    };
    const response = await fetch(apiUrl, requestOptions);
    if (!response.ok) {
      let errorMessage;
      try {
        const errorData = await response.json();
        errorMessage =
          errorData.message || `Request failed with status: ${response.status}`;
      } catch {
        errorMessage = `Request failed with status: ${response.status}`;
      }
      throw new Error(errorMessage);
    }
    const data = await response.json();
    return {
      success: true,
      data,
    };
  } catch (error) {
    console.error('Error fetching Assigned User list:');
    return {
      success: false,
      error: error.message || 'Failed to fetch Assigned User list',
    };
  }
};

export const downloadAssignedUserExcel = async (payload) => {
  try {
    const token = getAccessToken();
    const apiUrl = `${BASE_URL}/${DOWNLOAD_USER_ENTITY_EXCEL_API}`;
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(payload),
    };
    const response = await fetch(apiUrl, requestOptions);
    if (!response.ok) throw new Error(`Failed to download Assign Entity Excel: ${response.status}`);
    // Return as Blob (Excel file)
    const blob = await response.blob();
    return blob;
  } catch (err) {
    throw err;
  }
};

export const deleteAssignedUserEntity = async (uuid) => {
  try {
    const token = getAccessToken();
    const apiUrl = `${BASE_URL}/${DELETE_ASSIGNED_ENTITY_API}${uuid}`;
    const requestOptions = {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      }
    };
    const response = await fetch(apiUrl, requestOptions);
    if (!response.ok) {
      let errorMessage;
      try {
        const errorData = await response.json();        
        errorMessage =
          errorData.error || `Request failed with status: ${response.status}`;
      } catch {
        errorMessage = `Request failed with status: ${response.status}`;
      }
      throw new Error(errorMessage);
    }
    const data = await response.json();
    return {
      success: true,
      data,
    };
  } catch (error) {
    console.error('Error while deleting Assigned User Entity:');
    return {
      success: false,
      error: error.message || 'Failed to Delete Assigned User Entity',
    };
  }
};


export const deleteAssignedUserUpdateEntity = async (userId) => {
  try {
    const token = getAccessToken();
    const apiUrl = `${BASE_URL}/${DELETE_ASSIGNED_USER_ENTITY_API}${userId}`;
    const requestOptions = {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      }
    };
    const response = await fetch(apiUrl, requestOptions);
    if (!response.ok) {
      let errorMessage;
      try {
        const errorData = await response.json();        
        errorMessage =
          errorData.error || `Request failed with status: ${response.status}`;
      } catch {
        errorMessage = `Request failed with status: ${response.status}`;
      }
      throw new Error(errorMessage);
    }
    const data = await response.json();
    return {
      success: true,
      data,
    };
  } catch (error) {
    console.error('Error while deleting Assigned User Entity:');
    return {
      success: false,
      error: error.message || 'Failed to Delete Assigned User Entity',
    };
  }
};
